// src/app/core/store/claim-analytics/claim-analytics.actions.ts

import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ClaimOverviewRequest, ClaimOverviewRow,
  ClaimTimeSeriesRequest, ClaimTimeSeriesRow,
  ClaimBreakdownRequest, ClaimBreakdownRow,
  ClaimRankingsRequest, ClaimRankingsRow,
  ClaimComparisonRequest, ClaimComparisonRow,
  ClaimProductSummary, ClaimProductConfig,
  ClaimCauseLookupItem, HealthBenefitTypeLookupItem,
} from '@shared/models/claim-analytics.model';

// ── Products ─────────────────────────────────────────────────────────────────
export const CaProductActions = createActionGroup({
  source: 'ClaimAnalytics/Products',
  events: {
    'Load Products':         emptyProps(),
    'Load Products Success': props<{ products: ClaimProductSummary[] }>(),
    'Load Products Failure': props<{ error: string }>(),
    'Select Product':        props<{ productTypeId: number }>(),
  },
});

// ── Config ───────────────────────────────────────────────────────────────────
export const CaConfigActions = createActionGroup({
  source: 'ClaimAnalytics/Config',
  events: {
    'Load Config':         props<{ productTypeId: number }>(),
    'Load Config Success': props<{ productTypeId: number; config: ClaimProductConfig }>(),
    'Load Config Failure': props<{ error: string }>(),
  },
});

// ── Lookups ──────────────────────────────────────────────────────────────────
export const CaLookupActions = createActionGroup({
  source: 'ClaimAnalytics/Lookups',
  events: {
    'Load Casco Causes':                    emptyProps(),
    'Load Casco Causes Success':            props<{ causes: ClaimCauseLookupItem[] }>(),
    'Load Health Benefit Types':            emptyProps(),
    'Load Health Benefit Types Success':    props<{ types: HealthBenefitTypeLookupItem[] }>(),
  },
});

// ── Overview ─────────────────────────────────────────────────────────────────
export const CaOverviewActions = createActionGroup({
  source: 'ClaimAnalytics/Overview',
  events: {
    'Load':    props<{ request: ClaimOverviewRequest }>(),
    'Success': props<{ data: ClaimOverviewRow[] }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── TimeSeries ───────────────────────────────────────────────────────────────
export const CaTimeSeriesActions = createActionGroup({
  source: 'ClaimAnalytics/TimeSeries',
  events: {
    'Load':    props<{ request: ClaimTimeSeriesRequest }>(),
    'Success': props<{ data: ClaimTimeSeriesRow[] }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── Breakdown ────────────────────────────────────────────────────────────────
export const CaBreakdownActions = createActionGroup({
  source: 'ClaimAnalytics/Breakdown',
  events: {
    'Load':    props<{ request: ClaimBreakdownRequest }>(),
    'Success': props<{ data: ClaimBreakdownRow[] }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── Rankings ─────────────────────────────────────────────────────────────────
export const CaRankingsActions = createActionGroup({
  source: 'ClaimAnalytics/Rankings',
  events: {
    'Load':    props<{ request: ClaimRankingsRequest }>(),
    'Success': props<{ data: ClaimRankingsRow[] }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});

// ── Comparison ───────────────────────────────────────────────────────────────
export const CaComparisonActions = createActionGroup({
  source: 'ClaimAnalytics/Comparison',
  events: {
    'Load':    props<{ request: ClaimComparisonRequest }>(),
    'Success': props<{ data: ClaimComparisonRow[] }>(),
    'Failure': props<{ error: string }>(),
    'Clear':   emptyProps(),
  },
});
